import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

type Ctx = { node: ReactNode; setNode: (n: ReactNode) => void };

const PageHeaderContext = createContext<Ctx>({ node: null, setNode: () => {} });

/** Bọc quanh Header + nội dung để trang con có thể "bơm" cụm tiêu đề lên header. */
export function PageHeaderProvider({ children }: { children: ReactNode }) {
  const [node, setNode] = useState<ReactNode>(null);
  return (
    <PageHeaderContext.Provider value={{ node, setNode }}>{children}</PageHeaderContext.Provider>
  );
}

/** Header đọc nội dung được bơm vào. */
export function usePageHeaderSlot() {
  return useContext(PageHeaderContext).node;
}

/**
 * Đặt nội dung hiển thị bên trái header toàn cục; tự xóa khi rời trang.
 * Truyền `deps` để cập nhật khi dữ liệu (tên, slug, trạng thái…) thay đổi.
 */
export function usePageHeader(node: ReactNode, deps: unknown[] = []) {
  const { setNode } = useContext(PageHeaderContext);
  useEffect(() => {
    setNode(node);
    return () => setNode(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
